<template>
    <v-flex class="post-attachment" v-if="attachmentList && attachmentList.length">
        <v-expansion-panel>
            <v-expansion-panel-content>
                <div slot="header" class="panel-heading">
                    {{fileAttachmentConsts.ATTACHMENTS}}
                    <small data-qe-id="post_attachment_list_length">({{attachmentList.length}})</small>
                </div>

                <v-layout row wrap class="post-attachment__section"
                          v-for="(attachment,i) in attachmentList" :key="i">
                    <v-flex xs1 class="typeBlock">
                        <v-icon large
                                v-if="!isMobileAppBrowser"
                                :class='iconClassNames(attachment.mediaType)'
                                :data-qe-id="`attached_file_${i}_download_url_link`"
                                @click="downloadattachment(attachment.name, attachment.url)">
                        </v-icon>
                        <a :href="attachment.url" v-if="isMobileAppBrowser" download="attachment.name" target="_blank">
                        <v-icon large
                                :class='iconClassNames(attachment.mediaType)'
                                :data-qe-id="`attached_file_${i}_download_url_link`">
                        </v-icon>
                        </a>
                        <span :data-qe-id="`attached_file_${i}_size`">
                            {{calculateFileSize(attachment.size,communityCommonConstant.filesAndMedia)}}
                        </span>
                    </v-flex>
                    <v-flex xs8
                            pr-1
                            class="nameBlock">
                        <strong class="pointer"
                            v-if="!isMobileAppBrowser"
                            id="download_attachment_btn_unit_tests-desktop"
                            :data-qe-id="`attached_file_${i}_download_name_link`"
                            @click="downloadattachment(attachment.name, attachment.url)">
                        {{attachment.name}}
                        </strong>
                        <a :href="attachment.url" v-if="isMobileAppBrowser" download="attachment.name" target="_blank">
                        <strong class="pointer"
                                id="download_attachment_btn_unit_tests"
                                :data-qe-id="`attached_file_${i}_download_name_link`">
                            {{attachment.name}}
                        </strong>
                        </a>
                    </v-flex>
                    <v-flex xs3 v-if="canDelete"
                            text-xs-right
                            class="actionsBlock">
                        <v-btn class="primary_btn transparent small pa-1"
                               id="remove_attachment_btn_unit_tests"
                               :data-qe-id="`attached_file_${i}_remove_link`"
                               @click="removeAttachment(i)">
                            <i class="fas fa-trash-alt "></i>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { iconClassNames, communityCommonConstant, calculateFileSize } from "../../ChapterPage/communityCommon.constant";
    import { fileAttachmentConsts } from './FileAttachmentconstants';
    import { storeAction } from "@/store/storeActions.constant";
    import { storeGetters } from '@/store/storeGetters.constant';

    export default {
        name: 'PostAttachments',
        props: {
            attachmentList: {
                type: Array,
                required: true,
            },
            canDelete: {
                type: Boolean,
                default: false,
            },
            deleteAttachmentHandler: {
                type: Function,
                required: false,
            },
        },
        data: () => {
            return {
                communityCommonConstant,
                fileAttachmentConsts,
            };
        },
        computed: {
            ...mapGetters({
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
        },
        methods: {
            ...mapActions({
                downloadPostAttachment: `chapter/${storeAction.downloadPostAttachment}`,
                }),
            iconClassNames,
            calculateFileSize,
            removeAttachment(key) {
                if (this.deleteAttachmentHandler) {
                    this.deleteAttachmentHandler(key);
                }
            },
            downloadattachment(FileName, FileUrl) {
                this.downloadPostAttachment({ FileName, FileUrl });
            },
        },
    };

</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .post-attachment {
        &__section {
        padding: 10px 10px;
    }
    .typeBlock {
        span

    {
        color: $ypo-dark-background-gray;
        font-size: 9px;
        font-weight: bold;
        letter-spacing: 0.59px;
        line-height: 12px;
        display: block;
        text-transform: uppercase;
    }

    i {
        color: $ypo-dark-background-gray;
    }

    }

    .nameBlock {
        strong

    {
        color: $ypo_blue;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0.19px;
        line-height: 26px;
        word-break: break-all;
    }

    }
    }
</style>
